module.exports = __webpack_public_path__ + "img/lessonpre_arrow_down_blue.50ea24ca.svg";